import z from "zod";

import {
  Language,
  LANGUAGE_LABELS,
  LANGUAGE_PROFICIENCY_LABELS,
  LanguageProficiency,
} from "@/enums/languages";
import { closedEnum } from "@/schemas/closed-enum";
import { createIdSchema } from "@/schemas/createId";

export const LanguageSchema = z.object({
  id: z.string(),
  language: closedEnum(Language, LANGUAGE_LABELS),
  proficiency: closedEnum(
    LanguageProficiency,
    LANGUAGE_PROFICIENCY_LABELS,
  ).nullable(),
});

export const LanguageCreateSchema = LanguageSchema.extend({
  id: createIdSchema,
});
export type LanguageCreate = z.infer<typeof LanguageCreateSchema>;
